import http from "@/utils/http";
let hr = "/hrApi";
// let host = "/oaApi/nvc/public";
// // let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
  queryList: (data) => http.post(`${hr}/menuWeight/queryList`, data), // 菜单
  queryArticleList: (data) => http.post(`${hr}/menuWeight/queryArticleList`, data), // 列表
  queryComment: (data) => http.post(`${hr}/menuWeight/queryComment`, data), // 文章评论
  queryUserInfo: (data) => http.post(`${hr}/menuWeight/queryUserInfo`, data), // 获取用户信息
  addComment: (data) => http.post(`${hr}/menuWeight/addComment`, data), // 发送评论
  like: (data) => http.post(`${hr}/menuWeight/like`, data), // 点赞文章
  updateMenu: (data) => http.post(`${hr}/menuWeight/updateMenu`, data), // 删除隐藏
};
